export type InsuranceId =
  | "none"
  | "basic"
  | "standard"
  | "premium"
  | "car_basic"
  | "car_upgrade";

export interface Traveler {
  name: string;
  type: string;
  idCard: string;
  phone?: string;
  isDriver?: boolean;
  /** 出行人库ID（用于查看详情） */
  travelerId?: number;
  /** 是否为默认出行人 */
  isDefault?: boolean;
  licenseNo?: string;
  licenseType?: string;
  licenseExpiry?: string;
  /** 身份证正面 */
  idCardFront?: string;
  /** 身份证反面 */
  idCardBack?: string;
  /** 驾照正页 */
  licenseFront?: string;
  /** 驾照副页 */
  licenseBack?: string;
}

export type ProductType = "hotel" | "car" | "tour" | "guide";

export interface ProductInfo {
  icon: string;
  name: string;
  detail: string;
  spec: string;
  price: number;
  image: string;
}

export const BRAND = "#FF6B35";
